import React from 'react';
import { useNavigate } from 'react-router-dom';
import { StateScreen } from '../../components/StateScreen';
import { useLocale } from '../../contexts/LocaleContext';
import { useSession } from '../../contexts/SessionContext';
import { homePath } from '../../utils/clientReview';

/** MOB/Onboarding/Complete — short success, then Home. */
export function OnboardingComplete() {
  const {
    t
  } = useLocale();
  const navigate = useNavigate();
  const {
    completeOnboarding
  } = useSession();
  return <div className="min-h-screen w-full bg-deep pt-[max(12px,env(safe-area-inset-top))]" data-id="element-3427" data-mp="8d6q39erlnn0">
      <StateScreen tone="dark" tag={t('onb.done.tag')} title={t('onb.done.title')} body={t('onb.done.body')} points={[t('onb.done.p1'), t('onb.done.p2'), t('onb.done.p3')]} primary={{
      label: t('onb.done.cta'),
      onClick: () => {
        completeOnboarding();
        navigate(homePath(), {
          replace: true
        });
      }
    }} data-id="element-3428" data-mp="mc6h2npr2emc" />
    </div>;
}